@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- #FORM BODY -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
          {{'control-panel.users.user' | translate}}
        </label>
          <p-select [options]='usersList' [(ngModel)]="entity.user" dataKey='id' i18n-placeholder placeholder="{{'general.selectAnUser' | translate}}" optionLabel="formatUserLabel" appendTo='body'
              filter="true" [style]="{'min-width':'250px'}" [disabled]="!isNew" (onChange)="onChangeLeader($event)" (onFilter)="onFilterLeader($event)"
              >
              <ng-template pTemplate="selectedItem">
                @if (entity.user) {
                  <div class="flex align-items-center gap-2">
                    <div> {{ entity.user.surname1}} {{entity.user.surname2}}, {{ entity.user.name}}
                    </div>
                  </div>
                }
              </ng-template>
              <ng-template let-user pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div> {{user.surname1}} {{ user.surname2}}, {{ user.name}}
                  </div>
                </div>
              </ng-template>
            </p-select>
        </div>
      </div>
      <!-- FLEET LEADER -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
          {{ 'tableManagement.leaders.fleetLeader' | translate }}
        </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="entity.fleetLeader" />
        </div>
      </div>
      <!-- ZONE LEADER -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
          {{ 'tableManagement.leaders.zoneLeader' | translate }}
        </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="entity.zoneLeader" />
        </div>
      </div>
      <!-- SERVICE LEADER -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
          {{ 'tableManagement.leaders.serviceLeader' | translate }}
        </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="entity.serviceLeader" />
        </div>
      </div>
      <!-- ACTIVE -->
      <!--
      <div class="row mt-3">
        <div class="col d-flex align-items-center">
          <label for="vehicle-data-settings-name" class="custom-label" i18n>
            {{'general.active' | translate}}
          </label>
        </div>
        <div class="col">
          <div class="float-end">
            <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox"  [disabled]="true" [checked]="!entity.disabled" (change)="entity.disabled = !entity.disabled" />
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
            {{'general.save' | translate}}
          </button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
            {{'general.create' | translate}}
          </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!entity.disabled)" i18n>
            {{'general.changeStatus' | translate}}
          </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
</p-dialog>
}